var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1882 14.02C23.5022 11.924 21.9053 10.797 19.7233 10.045L20.4312 7.205L18.7033 6.775L18.0133 9.54C17.5592 9.426 17.0933 9.32 16.6283 9.214L17.3232 6.431L15.5953 6L14.8872 8.839C14.5113 8.753 14.1413 8.669 13.7833 8.579L13.7853 8.57L11.4013 7.975L10.9413 9.821C10.9413 9.821 12.2243 10.115 12.1973 10.133C12.8973 10.308 13.0233 10.771 13.0023 11.139L12.1962 14.374C12.2442 14.386 12.3063 14.404 12.3763 14.431L12.1933 14.386L11.0633 18.918C10.9773 19.13 10.7603 19.449 10.2703 19.328C10.2883 19.353 9.01425 19.015 9.01425 19.015L8.15625 20.993L10.4062 21.554C10.8242 21.659 11.2343 21.769 11.6372 21.872L10.9223 24.744L12.6493 25.174L13.3573 22.334C13.8293 22.461 14.2873 22.579 14.7353 22.691L14.0293 25.519L15.7573 25.949L16.4722 23.083C19.4202 23.641 21.6363 23.416 22.5693 20.75C23.3212 18.604 22.5323 17.365 20.9813 16.558C22.1113 16.298 22.9612 15.555 23.1882 14.02ZM19.2383 19.558C18.7053 21.705 15.0903 20.544 13.9183 20.253L14.8683 16.448C16.0403 16.741 19.7973 17.32 19.2383 19.558ZM19.7733 13.989C19.2863 15.942 16.2783 14.949 15.3033 14.706L16.1632 11.256C17.1383 11.499 20.2813 11.952 19.7733 13.989Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BTC.7778f76578ba8d29e4c72130a0eb906e.svg";